/*
  Keyboard avoidance (Oct 8, v5), site-wide, phones and tablets only.
  Only ONE thing ever moves the page, so nothing fights:
  - When you tap a text box that sits low on the screen (where the keyboard is about to land),
    the page is moved up right then, in the same instant as the tap and BEFORE the keyboard opens,
    so the box is already high on the screen. Safari then sees the box is clear and doesn't scroll.
  - Boxes that are already high, or that you reach with the keyboard's up/down arrows, are left
    to Safari alone.
  Also: smooth scrolling is off while typing (so nothing glides or overshoots), every box has
  extra margin for Safari's own scroll, and the hide-on-scroll header doesn't animate while typing.
  Boxes inside pop-ups and drawers are always left to Safari.
*/
(() => {
  if (window.__kbFit) return;
  window.__kbFit = true;
  const touch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
  if (!touch) return;
  const root = document.documentElement;
  const style = document.createElement('style');
  style.textContent =
    'input:not([type=checkbox]):not([type=radio]),textarea{scroll-margin-top:96px;scroll-margin-bottom:80px}' +
    'html.kb-typing,html.kb-typing .page-wrapper{scroll-behavior:auto!important}' +
    'html.kb-typing #header-component[sticky=scroll-up]{animation:none!important}';
  document.head.appendChild(style);
  const SKIP = ['checkbox', 'radio', 'hidden', 'range', 'submit', 'button', 'reset', 'file', 'color', 'image'];
  const isField = (el) => !!el && el.nodeType === 1 && (
    (el.tagName === 'INPUT' && !SKIP.includes((el.type || '').toLowerCase())) ||
    el.tagName === 'TEXTAREA' || el.isContentEditable
  );
  const inPanel = (el) => {
    if (el.closest('dialog, [role="dialog"]')) return true;
    for (let p = el.parentElement; p && p !== document.body && p !== root; p = p.parentElement) {
      const cs = getComputedStyle(p);
      if (cs.position === 'fixed') return true;
      if (/(auto|scroll)/.test(cs.overflowY) && p.scrollHeight > p.clientHeight + 2) return true;
    }
    return false;
  };

  let off = null, sx = 0, sy = 0, tapTarget = null;
  const typingOn = () => { clearTimeout(off); root.classList.add('kb-typing'); };

  document.addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    sx = t.clientX; sy = t.clientY;
    tapTarget = isField(e.target) ? e.target : null;
    if (tapTarget) typingOn();
  }, { passive: true, capture: true });

  /* the tap lands: lift the box before Safari focuses it and opens the keyboard */
  document.addEventListener('touchend', (e) => {
    const el = tapTarget;
    tapTarget = null;
    if (!el || document.activeElement === el) return;
    const t = e.changedTouches[0];
    if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) return; /* that was a scroll, not a tap */
    if (inPanel(el)) return;
    const r = el.getBoundingClientRect();
    const H = window.innerHeight;
    const want = Math.max(110, H * 0.2);           /* where the box should sit: upper part of the screen */
    if (r.top > H * 0.38 || r.top < 90) {          /* low enough that the keyboard would cover it, or tucked under the header */
      const by = Math.round(r.top - want);
      if (Math.abs(by) > 6) window.scrollBy(0, by);
    }
  }, { passive: true, capture: true });

  document.addEventListener('focusin', (e) => { if (isField(e.target)) typingOn(); });
  document.addEventListener('focusout', () => {
    clearTimeout(off);
    off = setTimeout(() => { if (!isField(document.activeElement)) root.classList.remove('kb-typing'); }, 500);
  });
})();
